// @ts-nocheck
import { create } from 'zustand';
import { Id } from '@/convex/_generated/dataModel';

interface ScheduleStore {
	expandedGroups: Record<string, boolean>;
	setExpandedGroup: (
		podId: Id<'engagementPods'>,
		isExpanded: boolean
	) => void;
	initializeFirstGroup: (firstPodId: Id<'engagementPods'>) => void;
}

export const useScheduleStore = create<ScheduleStore>((set) => ({
	expandedGroups: {},
	setExpandedGroup: (podId, isExpanded) =>
		set((state) => ({
			expandedGroups: {
				...state.expandedGroups,
				[podId]: isExpanded,
			},
		})),
	initializeFirstGroup: (firstPodId) =>
		set((state) => {
			if (Object.keys(state.expandedGroups).length === 0) {
				return {
					expandedGroups: { [firstPodId]: true },
				};
			}
			return state;
		}),
}));
